import { getNs } from 'aa_common/front-end'
import { IMPORT_EXPORT_EVENT_TYPES } from 'pages/assets/AssetListPage/import-export-event-type-selector'
import { useMemo } from 'react'
import { createColumn } from './helper'

const { t } = getNs(['components/organisms/assets/asset-import-result-list'])

export const useImportTables = (type: any, data: any) => {
  const dataTable = useMemo(() => {
    const dataSource = data?.map(function (item: any) {
      return { ...item, asset_branch_code: `${item?.asset_code} - ${item?.branch_code}` }
    })
    switch (type) {
      case IMPORT_EXPORT_EVENT_TYPES.START_USAGE:
        const columnsStartUsage = [
          createColumn('capture_image'),
          createColumn('asset_branch_code'),
          createColumn('asset_name'),
          createColumn('start_usage_at'),
          createColumn('cause_code'),
          createColumn('cause_name'),
          createColumn('reference_link'),
        ]
        return { dataSource, columns: columnsStartUsage }

      case IMPORT_EXPORT_EVENT_TYPES.IMPAIRMENT:
        const columnsImpairment = [
          createColumn('capture_image'),
          createColumn('asset_branch_code'),
          createColumn('asset_name'),
          createColumn('impaired_at'),
          createColumn('cause_code'),
          createColumn('cause_name'),
          createColumn('impair_dem'),
          createColumn('reference_link'),
        ]
        return { dataSource, columns: columnsImpairment }
      case IMPORT_EXPORT_EVENT_TYPES.ASSET_TYPE_MODIFICATION:
        const columnsAssetTypeModification = [
          createColumn('capture_image'),
          createColumn('asset_branch_code'),
          createColumn('asset_name'),
          createColumn('asset_type_depreciable_property_tax_name'),
          createColumn('asset_type_corporate_tax_name'),
          createColumn('asset_type_structure_corporate_tax'),
          createColumn('asset_type_detail_corporate_tax'),
        ]
        return { dataSource, columns: columnsAssetTypeModification }
      default:
        return { dataSource: [], columns: [] }
    }
  }, [type])

  return {
    dataTable,
  }
}
